import { useState } from "react";
import { Bounce } from "react-reveal";

function Waitlist() {
  const [user, setUser] = useState({
    Name: '', Email: ''
  });
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [disableSubmit, setDisableSubmit] = useState(true);

  const data = (e) => {
    setUser(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));

    // Check if all fields are filled
    if (user.Name && user.Email) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  };

  const getData = async (e) => {
    e.preventDefault();
    const { Name, Email } = user;

    // Check email format
    const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailFormat.test(Email)) {
      setRegistrationStatus('invalidEmail');
      return;
    }

    // Check if email already exists in the database
    const res = await fetch(
      'https://walkers-5517a-default-rtdb.firebaseio.com/UserData.json'
    );
    if (res.ok) {
      try {
        const data = await res.json();
        const emails = Object.values(data).map(user => user.Email);
        if (emails.includes(Email)) {
          setRegistrationStatus('emailExists');
          return;
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
        setRegistrationStatus('failure');
        return;
      }
    } else {
      console.error('Error fetching data:', res.status);
      setRegistrationStatus('failure');
      return;
    }

    // If email doesn't exist, proceed with registration
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ Name, Email })
    };
    const registrationResponse = await fetch(
      'https://walkers-5517a-default-rtdb.firebaseio.com/UserData.json',
      options
    );
    if (registrationResponse.ok) {
      setRegistrationStatus('success'); // Set registration status to success
    } else {
      console.error('Error registering user:', registrationResponse.status);
      setRegistrationStatus('failure'); // Set registration status to failure
    }

    // Reset form and registration status after submission
    setUser({ Name: '', Email: ''});
    setTimeout(() => {
      setRegistrationStatus(null);
    }, 3000); // Clear the message after 3 seconds
  };

  return (
    <div className='py-[5%] lg:py-[3%] bg-[#F9F9FB] m-[3%] flex flex-col justify-center items-center rounded-2xl'>
      <div className='flex flex-col items-center'>
        <Bounce>
          <h1 className='text-2xl lg:text-4xl'>Join Our Waitlist</h1>
        </Bounce>
        <h4 className='text-sm lg:text-lg lg:py-2 px-5 text-center lg:pb-5'>Fill in your details so we can keep you up to date with the announcements and upcoming events</h4>
      </div>
      <div className='flex flex-col items-center justify-center mt-5 bg-[#fff] rounded-xl mx-[4%] w-full p-5 md:w-[500px] border-2 border-[#2f59bc17] shadow-lg shadow-[ 0px 17px 36px rgba(0, 0, 0, 0.02)]'>
        <form method="POST" className='w-full'>
          <h3 className='text-lg lg:text-xl'>Name</h3>
          <input required className='bg-[#F9F9FB] px-2 py-3  rounded-xl w-full text-sm lg:text-base' name="Name" placeholder='Full Name' autoComplete="off" value={user.Name} onChange={data} />
          <h3 className='pt-[8%] text-lg lg:text-xl'>Email</h3>
          <input required className='bg-[#F9F9FB] px-2 py-3 rounded-xl w-full text-sm lg:text-base' name="Email" type='email' autoComplete="off" value={user.Email} onChange={data} placeholder='Email Address' />
        </form>
        {registrationStatus === 'success' && <p style={{ color: 'green' }}>Registration successful</p>}
        {registrationStatus === 'failure' && <p style={{ color: 'red' }}>Come back in a few mins</p>}
        {registrationStatus === 'invalidEmail' && <p style={{ color: 'red' }}>Invalid email format</p>}
        {registrationStatus === 'emailExists' && <p style={{ color: 'red' }}>Email already exists</p>}
        <div>
          <button onClick={getData} type='submit' disabled={disableSubmit} className={`bg-black animate-pulse text-white mt-3 lg:mt-7 flex p-2 pl-3 lg:p-3 rounded-md text-base  lg:text-xl justify-center items-center ${disableSubmit && 'opacity-50 cursor-not-allowed'}`}>
            <span className='px-1'>Submit</span>
            <img className='hidden lg:flex'
              src="https://icongr.am/material/foot-print.svg?size=29&color=ffffff"
              alt="Footprint Icon"
              style={{ transform: 'scaleX(-1)', marginTop: '-1%', marginLeft: '-4%' }}
            />
            <img className='lg:hidden flex items-center'
              src="https://icongr.am/material/foot-print.svg?size=20&color=ffffff"
              alt="Footprint Icon"
              style={{ transform: 'scaleX(-1)', marginTop: '2.5%', marginLeft: '-4%' }}
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Waitlist;
